export class MenuFontFamilyList {
    static list = ['Arial', 'Courier New', 'Garamond', 'Microsoft Sans Serif', 'Tahoma', 'Times New Roman', 'Verdana'];
    static default = 'Arial';
}
